export const UNLIMITED_QUESTION_QUOTA = 9999999;

export const quotaParser = (quota, isUnlimited = false) =>
  !isUnlimited && quota < UNLIMITED_QUESTION_QUOTA ? quota : '∞';



// WEBPACK FOOTER //
// ./app/utils/quotaParser.js